import { Input } from '@/components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

import { VariableAutocomplete } from '../VariableAutocomplete';

import type { StockNodeData } from '@repo/shared-types';

interface StockConfigProps {
  data: StockNodeData;
  onChange: (data: StockNodeData) => void;
}

export const StockConfig = ({ data, onChange }: StockConfigProps) => {
  const update = (fields: Partial<StockNodeData>) => {
    onChange({ ...data, ...fields });
  };

  return (
    <div className="space-y-4">
      <div>
        <label className="mb-1 block text-xs font-medium text-gray-400">Label</label>
        <Input
          value={data.label || ''}
          onChange={(e) => update({ label: e.target.value })}
          placeholder="Stock Lookup"
        />
      </div>

      <div>
        <label className="mb-1 block text-xs font-medium text-gray-400">Action</label>
        <Select
          value={data.action || 'search'}
          onValueChange={(v) => update({ action: v as 'search' | 'list' })}
        >
          <SelectTrigger>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="search">Search (single result)</SelectItem>
            <SelectItem value="list">List (multiple results)</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div>
        <label className="mb-1 block text-xs font-medium text-gray-400">Search By</label>
        <Select
          value={data.searchBy || 'registration'}
          onValueChange={(v) =>
            update({ searchBy: v as 'registration' | 'vin' | 'stock_listing_id' })
          }
        >
          <SelectTrigger>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="registration">Registration</SelectItem>
            <SelectItem value="vin">VIN</SelectItem>
            <SelectItem value="stock_listing_id">Stock Listing ID</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div>
        <label className="mb-1 block text-xs font-medium text-gray-400">
          Search Value (supports variables like {'{{call.lead_data.registration}}'})
        </label>
        <VariableAutocomplete
          value={data.searchValue || ''}
          onChange={(v) => update({ searchValue: v })}
          placeholder="{{call.lead_data.registration}}"
        />
      </div>

      <div>
        <label className="mb-1 block text-xs font-medium text-gray-400">Output Key</label>
        <Input
          value={data.outputKey || 'stock'}
          onChange={(e) => update({ outputKey: e.target.value })}
          placeholder="stock"
        />
        <p className="mt-1 text-[10px] text-gray-500">
          Results will be available as {'{{stock.<field>}}'} in downstream nodes.
        </p>
      </div>
    </div>
  );
};
